import axios from 'axios';
axios.defaults.timeout = 50000;
axios.baseUrl = process.env.VUE_APP_API_URL;
//http request 拦截器
console.log(getUrlSearch('t')  , 'getUrlSearch("t")') 
import {setCookie,getCookie} from '@/utils/cookie.js'
import { refreshToken } from "@/utils/getData.js";


axios.interceptors.request.use(config => {
    config.baseURL = process.env.VUE_APP_API_URL;
    // config.headers['Content-Type'] = config.contentType;
    // config.headers['Access-Token'] = getCookie('roomToken');
    return config;
},
    error => {
        return Promise.reject(error);
    }
);

axios.interceptors.response.use(res => {

    const code = res.data.code;

    if(code === 401){

        return refreshToken(getCookie('refreshToken')).then(newToken => {
            
            setCookie('accessToken',newToken.data.accessToken)
            setCookie('refreshToken',newToken.data.refreshToken)

            const config = {
                ...res.config,
                headers: {
                    ...res.config.headers,
                    Authorization: `Bearer ${getCookie('accessToken')}`,
                    'Content-Type': 'application/json'
                }
            };


            return axios(config)
        })
    }

    return res.data
}, error => {
    if (error.message.includes('timeout')) {
        //需要的其他操作
        return Promise.reject(error);
    }
    return Promise.reject(error);
})

function getUrlSearch(name) {
  if (!name) return null;
  var after = window.location.search;
  after = after.substr(1) || window.location.hash.split('?')[1];
  if (!after) return null;
  if (after.indexOf(name) === -1) return null;
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  var r = decodeURI(after).match(reg);
  if (!r) return null;
  return r[2];
}
export default axios